document.querySelectorAll('.header [data-toggle-menu]').forEach(i => {
    i.addEventListener('click', e => {
        e.preventDefault();
        i.classList.toggle('open');
        document.querySelector('.header').classList.toggle('header--nav-open');
        document.querySelector('.nav').classList.toggle('nav--open');
        document.querySelector('html').classList.toggle('html--nav--open');
        document.querySelectorAll('.header .nav__control').forEach(i => {
            i.checked = '';
        });
    })
});